// The one <style>, inserted once per page.
//
// A <style> injected from the bundle rather than a second <link>, for three
// reasons: one URL means one cache entry and one version, so a customer can
// never end up with our JavaScript v2 and our CSS v1; a <link> would be a
// second round trip and render-blocking, where a <style> inserted before the
// first paint has no flash of unstyled form; and the sheet is about two
// kilobytes, so splitting it to cache it separately saves nothing measurable.

import sheet from "./signup.css"

const MARKER = "data-mk-signup-styles"

export function installStyles() {
  if (document.querySelector(`style[${MARKER}]`)) return

  const style = document.createElement("style")
  style.setAttribute(MARKER, "1")
  style.textContent = sheet

  const head = document.head || document.documentElement

  // FIRST child of <head>, and this placement is the whole override story.
  // Every rule in the sheet is one class, and a customer overriding
  // .mk-signup__input writes one class too -- a specificity tie, decided by
  // source order. Inserting first means every stylesheet on the host page,
  // wherever it sits, comes later and wins. Appending would mean we win, which
  // is the opposite of the design.
  head.insertBefore(style, head.firstChild)
}
